/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
import Service, { service } from '@ember/service';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { isEmpty } from '@ember/utils';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class FeaturesService extends Service {
  @service
  session;

  @service
  roles;

  @service
  options;

  @alias('session.school.heroDuoAvailable')
  heroDuoAvailable;

  @alias('session.school.heroSuiteAvailable')
  heroSuiteAvailable;

  @alias('session.school.pupilBillingAvailable')
  pupilBillingAvailable;

  @alias('session.school.heroDuoEnabled')
  heroDuoEnabled;

  @alias('session.school.heroPremierEnabled')
  heroPremierEnabled;

  @alias('session.school.heroSuiteEnabled')
  heroSuiteEnabled;

  @alias('session.school.pupilBillingEnabled')
  pupilBillingEnabled;

  @alias('session.school.multiJurisdictionalEnabled')
  multiJurisdictionalEnabled;

  // Base pack for NSW schools using the pack system
  @alias('session.school.heroStarterPackEnabled')
  heroStarterPackEnabled;

  // HERO Feature Packs
  // Available
  @alias('session.school.pagesPowerUpAvailable')
  pagesPowerUpAvailable;

  @alias('session.school.milestonesPowerUpAvailable')
  milestonesPowerUpAvailable;

  @alias('session.school.goalsPowerUpAvailable')
  goalsPowerUpAvailable;

  @alias('session.school.reportingPowerUpAvailable')
  reportingPowerUpAvailable;

  @alias('session.school.communicationsExtensionKitAvailable')
  communicationsExtensionKitAvailable;

  @alias('session.school.administrationExtensionKitAvailable')
  administrationExtensionKitAvailable;

  // Enabled
  @alias('session.school.pagesPowerUpEnabled')
  pagesPowerUpEnabled;

  @alias('session.school.milestonesPowerUpEnabled')
  milestonesPowerUpEnabled;

  @alias('session.school.goalsPowerUpEnabled')
  goalsPowerUpEnabled;

  @alias('session.school.reportingPowerUpEnabled')
  reportingPowerUpEnabled;

  @alias('session.school.communicationsExtensionKitEnabled')
  communicationsExtensionKitEnabled;

  @alias('session.school.administrationExtensionKitEnabled')
  administrationExtensionKitEnabled;

  @alias('session.school.absenceReportingAvailable')
  absenceReportingAvailable;

  // SAP finance support, built for NSW (but might be useful elsewhere later).
  @computed('session.school.jurisdiction', 'pupilBillingEnabled')
  get sapFinance() {
    return (
      this.pupilBillingEnabled &&
      this.get('session.school.jurisdiction') === Jurisdiction.AU_NSW
    );
  }

  @optionAlias('hero:features:reporting')
  reportingEnabled;

  @alias('session.school.cometEnabled')
  cometEnabled;

  // sidekickEnabled specifies if Sidekick is enabled for this school.
  @alias('session.school.sidekickEnabled')
  sidekickEnabled;

  @alias('session.school.eventsEnabled')
  eventsEnabled;

  // linkedGoalsEnabled specifies if linking Goals (Topics) is enabled.
  @alias('session.school.linkedGoalsEnabled')
  linkedGoalsEnabled;

  // controlPanelEnabled specifies if the landing page for a school user should be the control panel.
  @alias('session.school.controlPanelEnabled')
  controlPanelEnabled;

  // individualReportSnapshotsEnabledAndAccessible specifies if Individual Report Snapshots are enabled
  // for staff members who are not restricted
  @computed('session.{school.reportSnapshotsEnabled,person.roles.[]}')
  get individualReportSnapshotsEnabledAndAccessible() {
    return (
      this.session.school.reportSnapshotsEnabled &&
      !this.roles.currentUserIsRestricted
    );
  }

  // teRitoEnabled specifies if Te Rito is enabled for this school.
  @alias('session.school.teRitoEnabled')
  teRitoEnabled;

  @computed(
    'session.{school.[reportSnapshotsEnabled,jurisdiction],person.roles.[]}',
  )
  get schoolWideReportSnapshotsEnabled() {
    if (isEmpty(this.session.school)) {
      // No school - no checks
      return false;
    }

    return (
      this.session.school.reportSnapshotsEnabled &&
      !this.roles.currentUserIsRestricted
    );
  }
}
